import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import { __, _i } from "../../../utils";
import { Popover } from "antd";
import { useRouteBlocker } from "../../../hooks";
import { useStores } from "../../../store";
import { useCookieExpertsModal } from "@devowl-wp/react-cookie-banner-admin";
const ScannerExternalUrlActionPopover = observer((param)=>{
    let { item } = param;
    const [isVisible, setIsVisible] = useState(false);
    const { cookieStore: { essentialGroup } } = useStores();
    const { openDialog } = useCookieExpertsModal();
    const { data: { host } } = item;
    const { addLink: addBlockerLink } = useRouteBlocker();
    const toggleVisible = useCallback(()=>{
        setIsVisible(!isVisible);
    }, [
        isVisible
    ]);
    const openCookieExperts = useCallback(()=>{
        setIsVisible(false);
        openDialog();
    }, [
        openDialog
    ]);
    // Always navigate back to the scanner results
    const navigateAfterCreation = `navigateAfterCreation=${encodeURIComponent(window.location.href)}`;
    return /*#__PURE__*/ _jsx(Popover, {
        open: isVisible,
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("p", {
                    children: /*#__PURE__*/ _jsx("strong", {
                        children: _i(__("Does {{i}}%s{{/i}} belong to an essential service without which your website would technically no longer work?", host), {
                            i: /*#__PURE__*/ _jsx("i", {})
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("p", {
                    children: [
                        /*#__PURE__*/ _jsx("a", {
                            className: "button button-primary",
                            href: `${addBlockerLink}?force=scratch&attributes=${JSON.stringify({
                                rules: `*${host}*`
                            })}&${navigateAfterCreation}`,
                            children: __("No")
                        }),
                        "\xa0",
                        /*#__PURE__*/ _jsx("a", {
                            className: "button",
                            href: `#/cookies/${essentialGroup == null ? void 0 : essentialGroup.key}/new?force=scratch&${navigateAfterCreation}`,
                            children: __("Yes")
                        }),
                        "\xa0",
                        /*#__PURE__*/ _jsx("button", {
                            className: "button",
                            onClick: openCookieExperts,
                            children: __("I do not know")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "description",
                    children: _i(__("{{strong}}No:{{/strong}} Non-essential services that process personal data (e.g. IP address in some countries) or set cookies may only be loaded after consent. You should block them using a content blocker until consent is given. {{i}}Examples would be iframes, YouTube and similar embeddings or tracking tools.{{/i}}"), {
                        strong: /*#__PURE__*/ _jsx("strong", {}),
                        i: /*#__PURE__*/ _jsx("i", {})
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "description",
                    children: _i(__("{{strong}}Yes (rare cases):{{/strong}} You should inform your users about the use of the service in the essential services group. You do not need to create a content blocker, as the service can be loaded without consent. {{i}}Examples are privacy-friendly spam protection tools or security tools.{{/i}}"), {
                        strong: /*#__PURE__*/ _jsx("strong", {}),
                        i: /*#__PURE__*/ _jsx("i", {})
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: /*#__PURE__*/ _jsx("button", {
                        className: "button",
                        onClick: toggleVisible,
                        children: __("Close")
                    })
                })
            ]
        }),
        placement: "right",
        overlayStyle: {
            maxWidth: 350
        },
        children: /*#__PURE__*/ _jsx("a", {
            onClick: toggleVisible,
            children: __("Handle external URL")
        })
    });
});
export { ScannerExternalUrlActionPopover };
